import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import { LanguageProvider } from '@context/LanguageContext'
import { LayoutProvider } from '@context/LayoutContext'
import { MemoramaProvider } from '@games/memorama/context/MemoramaContext'
import { PuzzleProvider } from '@games/puzzle/context/PuzzleContext'
import LanguageDetector from '@components/interface/LanguageDetector'
import { LANGUAGE_INFO } from '@constants/languages'
import StaticPageHandler from '@components/pages/StaticPageHandler'
import ScreenWrapper from '@components/layout/ScreenWrapper'
import NotFound from '@components/pages/NotFound'

export default function AppRouter () {
  let devRoutes = null

  // Dev-only routes are fully excluded from production builds
  if (import.meta.env.DEV) {
    const DevTestEnd = lazy(() => import('@dev/TestEndScreen'))

    devRoutes = (
      <Route
        path='/test-end' element={
          <Suspense fallback={null}>
            <DevTestEnd />
          </Suspense>
        }
      />
    )
  }

  return (
    <BrowserRouter>
      <LanguageProvider>
        <LayoutProvider>
          <Routes>
            {/* Language detection route: redirects based on localStorage/browser preferences */}
            <Route path='/' element={<LanguageDetector />} />

            {/* Language specific routes: serve App content in specific language */}
            {LANGUAGE_INFO.map(({ code }) => (
              <Route key={code} path={`/${code}`} element={<App />} />
            ))}

            {/* Memorama route: SCOPED GameProvider */}
            {LANGUAGE_INFO.map(({ code }) => (
              <Route
                key={`${code}-memorama`} path={`/${code}/memorama`} element={
                  <MemoramaProvider>
                    <App />
                  </MemoramaProvider>
                  }
              />
            ))}

            {/* Puzzle route: SCOPED PuzzleProvider */}
            {LANGUAGE_INFO.map(({ code }) => (
              <Route
                key={`${code}-puzzle`} path={`/${code}/puzzle`} element={
                  <PuzzleProvider>
                    <App />
                  </PuzzleProvider>
                  }
              />
            ))}

            {/* Static pages: Dynamic route */}
            <Route path='/:lang/:page' element={<StaticPageHandler />} />

            {/* Development route */}
            {devRoutes}

            <Route
              path='*'
              element={
                <div className='app-layout'>
                  <ScreenWrapper>
                    <NotFound />
                  </ScreenWrapper>
                </div>
              }
            />
          </Routes>
        </LayoutProvider>
      </LanguageProvider>
    </BrowserRouter>
  )
}
